import { render, staticRenderFns } from "./UserGeneral.vue?vue&type=template&id=123fb0b0&scoped=true&"
import script from "./UserGeneral.vue?vue&type=script&lang=js&"
export * from "./UserGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UserGeneral.vue?vue&type=style&index=0&id=123fb0b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fb0b0",
  null
  
)

export default component.exports